module.exports = __webpack_public_path__ + "static/don42-91614c71800328da73e2b660ca12dd68.jpg";